"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartingPalette = void 0;
const index_1 = __importDefault(require("color/index"));
const d3_interpolate_1 = require("d3-interpolate");
const range_1 = __importDefault(require("lodash/range"));
const zip_1 = __importDefault(require("lodash/zip"));
const Color_1 = __importDefault(require("../Color"));
const palette = [
    'hsl(288,31%,61%)',
    'hsl(266,40%,44%)',
    'hsl(241,48%,54%)',
    'hsl(216,89%,66%)',
    'hsl(180,73%,53%)',
    'hsl(157,68%,56%)',
    'hsl(112,83%,67%)',
    'hsl(083,77%,60%)',
    'hsl(065,80%,58%)',
    'hsl(043,99%,71%)',
    'hsl(031,94%,61%)',
    'hsl(004,99%,64%)',
    'hsl(-13,82%,59%)',
];
const hsl = (0, zip_1.default)(...palette.map(c => (0, index_1.default)(c).hsl().array()));
const h = (0, d3_interpolate_1.interpolateBasis)(hsl[0]);
const s = (0, d3_interpolate_1.interpolateBasis)(hsl[1]);
const l = (0, d3_interpolate_1.interpolateBasis)(hsl[2]);
class AutoColor extends Color_1.default {
    constructor(index, total) {
        const t = index / total;
        const values = [h(t), s(t), l(t)].map(Math.round);
        const main = index_1.default.hsl(...values).string();
        super(main);
    }
}
const generatePalette = (size) => (0, range_1.default)(size).map(i => new AutoColor(i, size - 1 || 1));
// const generatePurplePalette = (size: number): Color[] => generatePalette(size * 3).splice(0, size)
// const generateGreenyPalette = (size: number): Color[] => generatePalette(size * 3).splice(size, size)
// const generateOrangePalette = (size: number): Color[] => generatePalette(size * 3).splice(size * 2, size)
const generatePrimaryPalette = (size) => generatePalette(size * 3).splice(Math.round(size * 0.5), size);
const generateSecondaryPalette = (size) => generatePalette(size * 3).splice(Math.round(size * 1.5), size);
// let rr = -1
// const getPalette = (s) => {
// 	rr = (rr + 1) % 3
// 	return rr === 0
// 		? generatePurplePalette(s)
// 		: rr === 1
// 			? generateGreenyPalette(s)
// 			: generateOrangePalette(s)
// }
const getPSPalete = (type, ss) => {
    let p;
    if (['place', 'position', 'userType'].includes(type)) {
        p = generatePrimaryPalette(ss);
    }
    else {
        p = generateSecondaryPalette(ss);
    }
    return p;
};
const paletteCache = {};
exports.ChartingPalette = {
    assignColor: (id, type, count) => {
        const size = Math.max(count, 6);
        if (!paletteCache[type]) {
            paletteCache[type] = {};
        }
        if (!paletteCache[type].palette || paletteCache[type].palette.length === 0) {
            paletteCache[type].palette = getPSPalete(type, size);
        }
        if (!paletteCache[type][id]) {
            if (id === 'label') {
                paletteCache[type][id] = paletteCache[type].palette[1];
            }
            else {
                paletteCache[type][id] = paletteCache[type].palette.shift();
            }
        }
        return paletteCache[type][id];
    },
    generatePalette,
};
exports.default = exports.ChartingPalette;
